export interface SolarInfo {
    date: string;
    day: number;
    month: number;
    year: number;
    dayOfWeek: number;
    weekOfYear: number;
}

export interface LunarInfo {
    day: number;
    month: number;
    year: number;
    isLeapMonth: boolean;
    yearName: string;
}

export interface CanChiInfo {
    year: string;
    month: string;
    day: string;
}

export interface CalendarDateResponse {
    solar: SolarInfo;
    lunar: LunarInfo;
    canChi: CanChiInfo;
    goodHours: string[];
    holidays: string[];
    specialDays?: string[];
}

export interface CalendarDayBrief {
    date: string;
    lunar: LunarInfo;
    canChi: CanChiInfo;
}

export interface CalendarMonthResponse {
    year: number;
    month: number;
    days: CalendarDayBrief[];
}

// Vietnamese weekday names
export const WEEKDAYS_VI = [
    'Chủ Nhật',
    'Thứ Hai',
    'Thứ Ba',
    'Thứ Tư',
    'Thứ Năm',
    'Thứ Sáu',
    'Thứ Bảy',
];

// Vietnamese month names
export const MONTHS_VI = [
    'Tháng Một',
    'Tháng Hai',
    'Tháng Ba',
    'Tháng Tư',
    'Tháng Năm',
    'Tháng Sáu',
    'Tháng Bảy',
    'Tháng Tám',
    'Tháng Chín',
    'Tháng Mười',
    'Tháng Mười Một',
    'Tháng Mười Hai',
];
